/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import TextContainer from "../../../../components/Container/TextContainer";
import Layout from "../../../Layouts/Layout";
import guidebookOverviewPageStyle from "../../Generic/GenericGuidebookPage/guidebookOverviewPageStyle";
import CardLinked from "../../../../components/Cards/CardLinked/CardLinked";
import * as guidebookTrafficContent from "./GuidebookTrafficCardContent";
import Grid from "@mui/material/Grid";
import { Helmet } from "react-helmet-async";
import Container from "../../../../components/Container/Container";
import { gaSet } from "../../../../services/cookieService";
import Typography from "@mui/material/Typography";

class GuidebookTrafficLawOverview extends React.Component {
  render() {
    const title = "Ratgeber Verkehrsrecht | Legalbird";
    gaSet({ title: title });

    return (
      <Layout backgroundType={"serviceworld"}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Container>
          <Typography variant={"h1"} sx={guidebookOverviewPageStyle.overviewHeading}>
            Ratgeber Verkehrsrecht
          </Typography>
        </Container>
        <TextContainer>
          <Grid container spacing={5} alignItems={"stretch"}>
            <Grid item xs={12} sm={6}>
              <CardLinked
                linkTo={guidebookTrafficContent.guidebookTrafficAccusation.linkTo}
                image={guidebookTrafficContent.guidebookTrafficAccusation.image}
                headline={guidebookTrafficContent.guidebookTrafficAccusation.headline}
                text={guidebookTrafficContent.guidebookTrafficAccusation.text}
                altTitle={guidebookTrafficContent.guidebookTrafficAccusation.altTitle}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CardLinked
                linkTo={guidebookTrafficContent.guidebookTrafficMinorOffence.linkTo}
                image={guidebookTrafficContent.guidebookTrafficMinorOffence.image}
                headline={guidebookTrafficContent.guidebookTrafficMinorOffence.headline}
                text={guidebookTrafficContent.guidebookTrafficMinorOffence.text}
                altTitle={guidebookTrafficContent.guidebookTrafficMinorOffence.altTitle}
              />
            </Grid>
          </Grid>
          <br />
        </TextContainer>
      </Layout>
    );
  }
}

export default GuidebookTrafficLawOverview;
